import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommandeService } from "../_services/commande.service";
import { DetailscommandeService } from "../_services/detailscommande.service";
import { FactureService } from "../_services/facture.service";
import { Commande } from "../models/Commande.model";
import { DetailCommande } from "../models/DetailCommande.model";
import { Facture } from "../models/Facture.model";
import { DomSanitizer } from "@angular/platform-browser";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { PaymentComponent } from "../payment/payment.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-details-commande",
  templateUrl: "./details-commande.component.html",
  styleUrls: ["./details-commande.component.scss"],
})
export class DetailsCommandeComponent implements OnInit {
  @Output() onOpenPaymentDialog: EventEmitter<any> = new EventEmitter();
  commande: Commande;
  detailcommande: DetailCommande[] = [];
  factures: Facture[] = [];
  restant = null;
  productEmpty = "assets/img/avatars/emptyProduit.jfif";
  constructor(
    private route: ActivatedRoute,
    private commandeService: CommandeService,
    public sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private detailscommandeService: DetailscommandeService,
    private spinner: NgxSpinnerService,
    private factureService: FactureService
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.commande = new Commande();
    if (this.route.snapshot.paramMap.get("id")) {
      this.commandeService
        .getOneData(this.route.snapshot.paramMap.get("id"))
        .subscribe((CommandeData: Commande) => {
          console.log(CommandeData);
          this.commande = CommandeData;
          this.restant = this.commande.montant - this.commande.avance;
          this.factures = this.commande.factures;
          this.detailcommande = this.commande.details_commandes;
          this.spinner.hide();
        });
    }
  }

  SendFactureAvanceByMail(idFacture) {
    console.log(idFacture);
    this.spinner.show();
    this.factureService.sendFactureAvanceByMail(idFacture).subscribe(
      (message) => {
        console.log(message);
        this.spinner.hide();
        this.AlertFactureSend();
      },
      (err) => {
        this.spinner.hide();
        this.AlertSendFail();
      }
    );
  }

  AlertFactureSend() {
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: "Facture envoyée avec succès !",
      footer: "Consultez votre adresse email.",
      showConfirmButton: false,
      timer: 2000,
    });
  }
  AlertSendFail() {
    Swal.fire({
      title:
        "Facture non envoyée vérifier votre connexion internet puis réessayer!!",
    }).then((result) => {
      if (result.value) {
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }
  public openPaymentDialog(command) {
    let dialogRef = this.dialog.open(PaymentComponent, {
      data: command,
      panelClass: "payment-dialog",
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe((message) => {
      if (message) {
        console.log(message);
        //this.getDetailsCommande();
        //this.router.navigate(['/products', product.id, product.name]);
      }
    });
  }
}
